<template>
  <main class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Send Out Message</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div>
              <form ref="observer" tag="form" @submit.prevent="submitForm()" :class="{ card: !isSubPage }" class="">
                <div class="grid">
                  <div class="col-12 md:col-12">
                    <div class="mb-2 font-bold text-sm">Select Channel *</div>
                    <div id="ctrl-channel-holder">
                      <Dropdown class="w-full" :class="getErrorClass('channel')" optionLabel="label" optionValue="value"
                        ref="ctrlchannel" v-model="formData.channel" :options="app.menus.channelTypesItems"
                        label="Channel" placeholder="Select a value ...">
                      </Dropdown>
                      <small v-if="isFieldValid('channel')" class="p-error">{{
                        getFieldError("channel")
                      }}</small>
                    </div>
                  </div>
                  <div v-if="isAppOrEmail()" class="col-12 md:col-6">
                    <div class="mb-2 font-bold text-sm">Category *</div>
                    <div id="ctrl-feed_type-holder">
                      <Dropdown class="w-full" :class="getErrorClass('feed_type')" optionLabel="label"
                        optionValue="value" ref="ctrlfeed_type" v-model="formData.feed_type"
                        :options="app.menus.feedTypeItems" label="Feed Type" placeholder="Select a value ...">
                      </Dropdown>
                      <small v-if="isFieldValid('feed_type')" class="p-error">{{
                        getFieldError("feed_type")
                      }}</small>
                    </div>
                  </div>
                  <div v-if="isAppOrEmail()" class="col-12 md:col-6">
                    <div class="mb-2 font-bold text-sm">Author *</div>
                    <div id="ctrl-author-holder">
                      <InputText ref="ctrlauthor" v-model.trim="formData.author" label="Author" type="text"
                        placeholder="Enter Author" class="w-full" :class="getErrorClass('author')">
                      </InputText>
                      <small v-if="isFieldValid('author')" class="p-error">{{
                        getFieldError("author")
                      }}</small>
                    </div>
                  </div>
                  <div v-if="isSmsOrEmail()" class="col-8 md:col-8">
                    <div class="mb-2 font-bold text-sm">Select primary recipient column *</div>
                    <div id="ctrl-recipient_column-holder">
                      <Dropdown class="w-full" :class="getErrorClass('recipient_column')" ref="ctrlrecipient_column"
                        v-model="formData.recipient_column" :options="formData.columns" label="Recipient Column"
                        placeholder="Select a value ...">
                      </Dropdown>
                      <small v-if="isFieldValid('recipient_column')" class="p-error">{{
                        getFieldError("recipient_column")
                      }}</small>
                    </div>
                  </div>
                  <div v-if="isSmsOrEmail()" class="col-4 md:col-4">
                    <div class="mt-4 font-bold text-sm"></div>
                    <div id="ctrl-media-holder">
                      <import-data label="Select a file to import" ref="dataimport"
                        :upload-path="`feeds/importdata?channel=${formData.channel}`" @importComplete="importComplete">
                        <Button @click="$refs.dataimport.openDialog()" label="Upload Recipients"
                          class="w-full p-button-info p-button-rounded" />
                      </import-data>
                    </div>
                  </div>
                  <div v-if="isAppOrEmail()" class="col-12 md:col-12">
                    <div class="mb-2 font-bold text-sm">Title *</div>
                    <div id="ctrl-title-holder">
                      <InputText ref="ctrltitle" v-model.trim="formData.title" label="Title" type="text"
                        placeholder="Enter Title" class="w-full" :class="getErrorClass('title')">
                      </InputText>
                      <small v-if="isFieldValid('title')" class="p-error">{{
                        getFieldError("title")
                      }}</small>
                    </div>
                  </div>
                  <div v-if="isAppOrEmailOrSms()" class="col-12 md:col-12">
                    <div class="mb-2 font-bold text-sm">Message *</div>
                    <div id="ctrl-message-holder">
                      <Textarea :class="getErrorClass('message')" class="w-full" ref="ctrlmessage" rows="5"
                        v-model="formData.message" placeholder="Enter Message" type="textarea">
                  </Textarea>
                      <small v-if="isFieldValid('message')" class="p-error">{{
                        getFieldError("message")
                      }}</small>
                    </div>
                    <Button v-for="(item, index) in formData.columns" :key="index" :label="item" type="button"
                      class="p-button-sm p-button-primary px-4 py-2 mt-2 mr-2 mb-1 p-button-rounded p-button-outlined"
                      @click="addKeyWord(`{${item}}`)" />
                  </div>
                  <div v-if="isApp()" class="col-12 md:col-6">
                    <div class="mb-2 font-bold text-sm">
                      Customer Status <i>(only if applicable)</i>
                    </div>
                    <div id="ctrl-customer_status-holder">
                      <div id="ctrl-customer_status-holder">
                        <Dropdown class="w-full" v-model="formData.customer_status" optionLabel="label"
                          optionValue="value" :options="app.menus.customerStatus" :class="getErrorClass('customer_status')"
                          placeholder="Select customer status ...">
                        </Dropdown>
                        <small v-if="isFieldValid('customer_status')" class="p-error">{{
                              getFieldError("customer_status") }}</small>
                      </div>
                    </div>
                  </div>
                  <div v-if="isApp()" class="col-12 md:col-6">
                    <div class="mb-2 font-bold text-sm">
                      Target Region <i>(only if applicable)</i>
                    </div>
                    <div id="ctrl-target_region-holder">
                      <div id="ctrl-region-holder">
                        <api-data-source api-path="components_data/region_option_list">
                          <template v-slot="req">
                            <MultiSelect class="w-full" :class="getErrorClass('target_region')" optionLabel="label"
                              optionValue="value" ref="ctrltarget_region" v-model="formData.target_region"
                              label="Target Region" :loading="req.loading" :options="req.response">
                            </MultiSelect>
                            <small v-if="isFieldValid('target_region')" class="p-error">{{
                              getFieldError("target_region") }}</small>
                          </template>
                        </api-data-source>
                      </div>
                    </div>
                  </div>
                  <div v-if="isApp()" class="col-12 md:col-6">
                    <div class="mb-2 font-bold text-sm">
                      Target District <i>(only if applicable)</i>
                    </div>
                    <div id="ctrl-target_district-holder">
                      <api-data-source
                        :api-path="`components_data/district_option_list_multi?lookup_region=${formData.target_region}`">
                        <template v-slot="req">
                          <MultiSelect class="w-full" :class="getErrorClass('target_district')" optionLabel="label"
                            optionValue="value" ref="ctrltarget_district" v-model="formData.target_district"
                            label="Target District" :loading="req.loading" :options="req.response">
                          </MultiSelect>
                          <small v-if="isFieldValid('target_district')" class="p-error">{{
                            getFieldError("target_district") }}</small>
                        </template>
                      </api-data-source>
                    </div>
                  </div>
                  <div v-if="isApp()" class="col-12 md:col-12">
                    <div class="mb-2 font-bold text-sm">Attach Image(s)</div>
                    <div id="ctrl-media-holder">
                      <div class="mb-3">
                        <Uploader :class="getErrorClass('media')" upload-path="s3uploader/upload/media"
                          v-model="formData.media" :fileLimit="7" :maxFileSize="3000000" accept=".jpg,.png,.gif,.jpeg"
                          :multiple="true" label="Choose files or drop files here" />
                      </div>
                      <small v-if="isFieldValid('media')" class="p-error">{{
                        getFieldError("media")
                      }}</small>
                    </div>
                  </div>
                </div>
                <div v-if="showSubmitButton" class="text-center my-3">
                  <Button class="p-button-primary" type="submit" label="Send Message" icon="pi pi-send"
                    :loading="saving" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { useAddPage } from "@/composables/addpage.js";
import { useApp } from "@/composables/app.js";
import { required, requiredIf } from "@/services/validators";
import useVuelidate from "@vuelidate/core";
import { computed, defineExpose, onMounted, reactive, ref, toRefs } from "vue";
const props = defineProps({
  pageName: {
    type: String,
    default: "feeds",
  },
  routeName: {
    type: String,
    default: "feedsadd",
  },
  apiPath: {
    type: String,
    default: "feeds/add",
  }, 
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgTitle: {
    type: String,
    default: "Create Record",
  },
  msgAfterSave: {
    type: String,
    default: "Record added successfully",
  },
  msgBeforeSave: {
    type: String,
    default: "",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  pageData: {
    // use to set formData default values from another page
    type: Object,
    default: () => { },
  },
});
const app = useApp();
const formDefaultValues = {
  channel: [],
  feed_type: "",
  author: "Ghana Water Info Center",
  title: "",
  message: "",
  media: "",
  target_region: [],
  target_district: [],
  customer_status: "",
  recipient_column: "",
  columns: [],
  track: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    channel: { required },
    feed_type: {
      required: requiredIf(() => {
        return isAppOrEmail();
      }),
    },
    author: {
      required: requiredIf(() => {
        return isAppOrEmail();
      }),
    },
    title: {
      required: requiredIf(() => {
        return isAppOrEmail();
      }),
    },
    message: {
      required: requiredIf(() => {
        return isAppOrEmailOrSms();
      }),
    },
    media: {},
    target_region: {},
    target_district: {},
    customer_status: {},
    recipient_column: {
      required: requiredIf(() => {
        return isSmsOrEmail();
      }),
    },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  app.flashMsg(props.msgTitle, props.msgAfterSave);
  page.setFormDefaultValues(); //reset form data
  if (app.isDialogOpen()) {
    app.closeDialogs(); // if page is open as dialog, close dialog
  } else if (props.redirect) {
    app.navigateTo(`/feeds`);
  }
}

function isApp() {
  return formData.channel == "app";
}
function isSmsOrEmail() {
  return formData.channel == "email" || formData.channel == "sms";
}
function isAppOrEmail() {
  return formData.channel == "email" || formData.channel == "app";
}
function isAppOrEmailOrSms() {
  return formData.channel == "email" || formData.channel == "app" || formData.channel == "sms";
}
function importComplete(response) {
  let res = JSON.parse(response);
  Object.assign(formData, { columns: res?.columns, track: res?.track })
}

const ctrlmessage = ref(null);

function addKeyWord(text) {
  const target = ctrlmessage.value.$el;
  if (target.setRangeText) {
    target.setRangeText(text);
    formData.message = target.value;
  }
}

const { submitted, saving, pageReady } = toRefs(page.state);
const {
  submitForm,
  getErrorClass,
  getFieldError,
  isFieldValid,
  mapOptionField,
} = page.methods;
onMounted(() => {
  const pageTitle = "Send Out Message";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
});
// expose page object for other components access
defineExpose({
  page, ctrlmessage
});
</script>
<style scoped></style>
